export const fabricStocks = (state = {}, action) => {
  if (action.type === 'FETCH_FABRIC_STOCKS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_FABRIC_STOCKS') {
    return {};
  }

  return state;
};

export const fabricInventory = (state = [], action) => {
  if (action.type === 'FETCH_FABRIC_INVENTORY') {
    return action.payload;
  }

  if (action.type === 'CLEAR_FABRIC_INVENTORY') {
    return [];
  }

  return state;
};

export const fabricInventoryStats = (state = [], action) => {
  if (action.type === 'FETCH_FABRIC_INVENTORY_STATS') {
    return action.payload;
  }

  if (action.type === 'CLEAR_FABRIC_INVENTORY_STATS') {
    return [];
  }

  return state;
};

export const fabricsForJobchart = (
  state = { fabricIndexes: {}, fabricNames: [], widths: {} },
  action
) => {
  if (action.type === 'FETCH_FABRICS_FOR_JOBCHART') {
    return action.payload;
  }

  if (action.type === 'CLEAR_FABRICS_FOR_JOBCHART') {
    return {
      fabricIndexes: {},
      fabricNames: [],
      widths: {},
    };
  }

  return state;
};

export const fabricInfo = (state = {}, action) => {
  if (action.type === 'FETCH_SINGLE_FABRIC_INFO') {
    return action.payload;
  }

  if (action.type === 'CLEAR_SINGLE_FABRIC_INFO') {
    return {};
  }

  return state;
};

export const fabricInfoToTransfer = (state = {}, action) => {
  if (action.type === 'FETCH_SINGLE_FABRIC_INFO_TO_TRANSFER') {
    return action.payload;
  }

  if (action.type === 'CLEAR_SINGLE_FABRIC_INFO_TO_TRANSFER') {
    return {};
  }

  return state;
};

export const fabricTransferHistory = (state = [], action) => {
  if (action.type === 'FETCH_FABRIC_TRANSFER_HISTORY') {
    return action.payload;
  }

  if (action.type === 'CLEAR_FABRIC_TRANSFER_HISTORY') {
    return [];
  }

  return state;
};

export const jobchartFabricsForRpo = (
  state = { productIndexes: {}, productNames: [], fabrics: [] },
  action
) => {
  if (action.type === 'FETCH_JOBCHART_FABRICS_FOR_RPO') {
    return action.payload;
  }

  if (action.type === 'CLEAR_JOBCHART_FABRICS_FOR_RPO') {
    return { productIndexes: {}, productNames: [], fabrics: [] };
  }

  return state;
};

export const fabricStocksForOutward = (
  state = { factories: {}, racknos: {}, stocks: {} },
  action
) => {
  if (action.type === 'FETCH_FABRIC_STOCKS_FOR_OUTWARD') {
    return action.payload;
  }

  if (action.type === 'CLEAR_FABRIC_STOCKS_FOR_OUTWARD') {
    return { factories: {}, racknos: {}, stocks: {} };
  }

  return state;
};

export const fabricTransferRequestCount = (state = 0, action) => {
  if (action.type === 'FETCH_PENDING_FABRIC_TRANSFER_REQUEST_COUNT') {
    return action.payload;
  }

  if (action.type === 'CLEAR_PENDING_FABRIC_TRANSFER_REQUEST_COUNT') {
    return 0;
  }

  return state;
};
